// StationList.js

import React from "react";
import { Box, Text, Card, Image} from "grommet";
import { Previous, Next } from 'grommet-icons';
import { useState, useEffect } from "react";


const stationCard = (item, stationChange, selectedStationId, setSelectedStationStr) => {
    // console.log('item >> ', item);
    return(
        <Box  background={selectedStationId === item.Id ? 'light-5' : "light-2"} 
            onClick={()=>{stationChange(item);}}
            key={item.Id} hoverIndicator round="small" margin="xsmall"
            width="90px" min-width="90px"  height="60px">

            <Card fill pad="xxsmall" >
                <Text  size="small" weight="bold"  
                    color={selectedStationId === item.Id ? 'neutral-2' : "neutral-3"} 
                    alignSelf="center" style={{whiteSpace: "nowrap"}}>{item.Name}</Text>
                <Box direction="row"  alignSelf="center">
                <Image
                    size="contain"
                    src="ScionIcon.png" 
                    width="30px"                                    
                    height="30px"                                   
                /> 
                <Image
                    size="contain"
                    src="ScionIcon.png" 
                    width="30px"                                    
                    height="30px"                                   
                />  
                </Box>                              
            </Card>
        </Box>
    );
}
    
const arrow = (arrowDirection, handleChange) => {
    const changeDirection = () => {
        if(arrowDirection === 'next')
            handleChange('right');
        else 
            handleChange('left');
    }

    return(
        <Box  onClick={changeDirection} hoverIndicator round="small" background="light-2"  margin="xsmall"  width="25px"  height="60px">
            <Card fill 
                style={{padding: "20px 10px 0 0px", weight: "bold" }}  
            >
            {(arrowDirection === 'next') && (
                <Next color='neutral-3' size='medium' /> 
            )}
            {(arrowDirection === 'prev') && (
                <Previous color='neutral-3' size='medium' />
            )}
            </Card>
        </Box>
    );
}


const StationList = (props) => {
    const {stations, stationChange, selectedStation, currentPage, visibleOnScreen} = props;
    const [currentData, setCurrentData] = useState(stations.slice(0, visibleOnScreen))
    const [indices, setIndices] = useState([0, visibleOnScreen]);
    // console.log(' 🖖 In StationList props >> ', props);

    useEffect(() => {
        const index = stations.findIndex((el) => el.Id === currentPage.Id || el.Id === selectedStation.Id);
        const startIndex = index !== -1 ? Math.max(0, index - Math.floor(visibleOnScreen / 2)) : 0;
        const endIndex = Math.min(startIndex + visibleOnScreen, stations.length);
    
        const nextData = stations.slice(startIndex, endIndex);
    
        setCurrentData(nextData);
        setIndices([startIndex, endIndex]);
    }, [currentPage, selectedStation, visibleOnScreen, stations]);
    

    const handleChange = (direction) => {
        let start = indices[0];
        let end = indices[1];

        if(direction === 'right')
        {
            end = Math.min(indices[1] + visibleOnScreen, stations.length) ;
            start = end - visibleOnScreen;           
        }
        else  if(direction === 'left')
        {
            start = Math.max(indices[0] - visibleOnScreen, 0) ;
            end = start + visibleOnScreen;
        }        
        // console.log('direction >> ', direction);
        // console.log('startIndex >> ', start);
        // console.log('endIndex >> ', end);        
        const nextData = stations.slice(start, end);
        setCurrentData(nextData);
        setIndices([start, Math.min(end, stations.length)]);
    };

    return (
        <Box margin={{vertical: "small"}}>           
            <Text  size="medium" weight="bold"  color="neutral-3" margin={{vertical: "xsmall"}}> Stations List: </Text>   
            <Box >
                <Box flex={false} pad="xsmall" direction="row">
                    {arrow('prev', handleChange)}
                    {currentData.map(datum => (stationCard(datum, stationChange, selectedStation.Id)) )}
                    {arrow('next', handleChange)}
                </Box>
                <Box alignSelf="start">
                    <Text  weight="bold" >
                    Showing {indices[0] + 1} - {indices[1]} of {stations.length}
                    </Text>
                </Box>
            </Box>
        </Box>
    );    
};

export default StationList;